import { WorkCalendarUserGroupModel } from "./work-calendar.state";

export class AddOrUpdateUserGroup {
    static readonly type = '[WorkCalendar UserGroupModel ] Add or Update';
    constructor(public payload: WorkCalendarUserGroupModel) {}
}

export class RemoveUserGroup {
    static readonly type = '[WorkCalendar UserGroupModel ] Remove';
    constructor(public groupId: number) {}
}

export class FetchWorkCalendarState {
    static readonly type = '[WorkCalendarState] Fetch State';
    constructor() {}
}